/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */

/**
 * Tipos de aviso in-app. Os mesmos valores aparecem no campo `event` do
 * fluxo SSE de `streamNotifications`.
 */
export type NotificationKind = typeof NotificationKind[keyof typeof NotificationKind];


export const NotificationKind = {
  message_received: 'message_received',
  announcement_published: 'announcement_published',
  class_reminder: 'class_reminder',
  schedule_change_proposed: 'schedule_change_proposed',
  makeup_requested: 'makeup_requested',
  makeup_answered: 'makeup_answered',
  recording_available: 'recording_available',
  charge_due: 'charge_due',
  payroll_statement_ready: 'payroll_statement_ready',
} as const;
